export default __webpack_public_path__ + "static/media/back-end.01dc677b.png";